import React from 'react';
import PropTypes from 'prop-types';

const PDPGalleryLabelsUI = ({ labels = [], loading = false }) => (
  <div className="flex">
    {!loading &&
      labels.map(label => (
        <div
          className="text-xs font-bold items-center bg-yellow-light rounded text-gray flex justify-center h-[25px] ml-2 pl-3 pr-3 first:ml-0 w-max"
          key={label}
        >
          {label}
        </div>
      ))}
  </div>
);

PDPGalleryLabelsUI.propTypes = {
  labels: PropTypes.arrayOf(PropTypes.string).isRequired,
  loading: PropTypes.bool,
};

export default PDPGalleryLabelsUI;
